import { render, staticRenderFns } from "./insureOrder.vue?vue&type=template&id=337d4f61&scoped=true&"
import script from "./insureOrder.vue?vue&type=script&lang=js&"
export * from "./insureOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337d4f61",
  null
  
)

export default component.exports